import { useState } from 'react';
import PageHero from '../components/PageHero';

const CAL_SRC =
  'https://calendar.google.com/calendar/embed?src=c94469cc2ad5e17bc730271c2069c8fb75e0a7e3d792dbbaba0c72b8d614722d%40group.calendar.google.com&ctz=America%2FLos_Angeles';

function Calendar() {
  const [password, setPassword] = useState('');
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === '6016') {
      setIsUnlocked(true);
      setError('');
    } else {
      setError('That password is not right. Please try again.');
    }
  };

  return (
    <div className="page">
      <PageHero kicker="For stylists" title="Booth calendar.">
        {isUnlocked
          ? 'Availability for chairs at The Loft. Reach out to the salon to claim an open slot.'
          : 'This calendar is for our stylists. Enter the salon password to view chair availability.'}
      </PageHero>

      <section className="section">
        <div className="container">
          {!isUnlocked ? (
            <form className="gate reveal" onSubmit={handleSubmit}>
              <label className="gate__label" htmlFor="cal-password">
                Salon password
              </label>
              <input
                id="cal-password"
                type="password"
                className="gate__input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter password"
                autoComplete="off"
                aria-describedby={error ? 'cal-error' : undefined}
                aria-invalid={error ? 'true' : 'false'}
              />
              {error && (
                <p className="gate__error" id="cal-error" role="alert">
                  {error}
                </p>
              )}
              <button type="submit" className="btn btn--primary gate__submit">
                Unlock calendar
              </button>
            </form>
          ) : (
            <div className="cal-embed frame reveal">
              <iframe
                title="The Loft Salon booth calendar"
                src={CAL_SRC}
                style={{ border: 0, width: '100%', height: '640px' }}
                frameBorder="0"
                scrolling="no"
              />
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Calendar;
